import axios from "axios";

export default axios.create({
    baseURL: "https://ritubroadband.in/api"
});
